import { observer } from 'mobx-react'
import { FC } from 'react'
import BindPhoneDialog from '../BindPhoneDialog/BindPhoneDialog'
import { uiController } from '@/controllers/uiController'

interface CommonDialogLayoutProps {}

const CommonDialogLayout: FC<CommonDialogLayoutProps> = observer(
  (props: CommonDialogLayoutProps) => {
    return (
      <div>
        <BindPhoneDialog
          onClose={() => {
            uiController.bindPhoneDialogProps.open = false
          }}
          {...uiController.bindPhoneDialogProps}
        />
      </div>
    )
  }
)

export default CommonDialogLayout
